module.exports = __webpack_public_path__ + "static/media/shopping_port_marker.c22b9584.svg";